import { Component, OnInit } from '@angular/core';

import { SearchSterlingService } from '../../services/search-sterling';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-sterling-form',
    templateUrl: 'sterling-form.html',
    styleUrls: ['sterling-form.css']
})

export class SterlingDetailComponent implements OnInit {

    id: string;
    formLoading = true;

    constructor(private search: SearchSterlingService,
        private route: ActivatedRoute,
        private router: Router, ) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.id = params['id'];
            this.search.getFile(this.id)
                .subscribe((result) => {
                    this.formLoading = false;
                    document.getElementById('htmlForm').innerHTML = result;
                });
        });
      }
}



// WEBPACK FOOTER //
// ./src/app/components/sterling-form/sterling-form.ts